module.exports = __webpack_public_path__ + "static/media/lightScooter.fc5c2854.svg";